import { ButtonHTMLAttributes, ReactNode } from 'react'

type ButtonVariant = 'primary' | 'dark' | 'ghost' | 'danger'

type ButtonSize = 'sm' | 'md' | 'lg'

type ButtonProps = {
  label?: string
  icon?: ReactNode
  iconPosition?: 'left' | 'right'
  variant?: ButtonVariant
  size?: ButtonSize
  block?: boolean
  iconOnly?: boolean
  loading?: boolean
  labelClassName?: string
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>

export const Button = ({
  label,
  icon,
  iconPosition = 'left',
  variant = 'primary',
  size = 'md',
  block = false,
  iconOnly = false,
  loading = false,
  labelClassName = '',
  disabled = false,
  className = '',
  type = 'button',
  ...buttonProps
}: ButtonProps) => {
  const classes = [
    'btn rounded-2',
    `btn-${variant}`,
    size !== 'md' ? `btn-${size}` : '',
    block ? 'btn-block' : '',
    iconOnly ? 'btn-icon' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const isDisabled = disabled || loading

  return (
    <button
      {...buttonProps}
      type={type}
      className={classes}
      disabled={isDisabled}
      aria-busy={loading}
      aria-label={buttonProps['aria-label'] ?? (iconOnly ? label : undefined)}
    >
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm"
            aria-hidden="true"
          />
          {!iconOnly && label && (
            <span className={labelClassName}>{label}</span>
          )}
        </>
      ) : (
        <>
          {iconPosition === 'left' && icon}
          {!iconOnly && label && (
            <span className={labelClassName}>{label}</span>
          )}
          {iconPosition === 'right' && icon}
        </>
      )}
    </button>
  )
}
